import { GearIcon, LogoutIcon, UserIcon } from "./icons";

export interface ProfileCardProps {
  /** Display name (bold line). */
  name: string;
  /** Secondary line — typically the e-mail. */
  email?: string;
  /** Optional avatar image URL; falls back to a silhouette glyph. */
  avatarSrc?: string;
  /** Settings action label (e.g. "Instellingen"). */
  settingsLabel: string;
  /** Logout action label (e.g. "Uitloggen"). */
  logoutLabel: string;
  /** Settings handler — omit to hide the settings action. */
  onSettings?: () => void;
  /** Logout handler. */
  onLogout: () => void;
}

/**
 * jve-2-6: the sidebar profile card — avatar + name/email header over a split
 * Settings | Logout action row (logout tinted danger). Mirrors the Jmix `.fawkes-profile-card`.
 * Presentational + extraction-ready; the host passes the resolved identity + handlers.
 */
export function ProfileCard({
  name,
  email,
  avatarSrc,
  settingsLabel,
  logoutLabel,
  onSettings,
  onLogout,
}: ProfileCardProps) {
  return (
    <div className="fui-profile">
      <div className="fui-profile__header">
        <span
          className="fui-profile__avatar"
          data-photo={avatarSrc ? "" : undefined}
          style={avatarSrc ? { backgroundImage: `url(${avatarSrc})` } : undefined}
          aria-hidden="true"
        >
          {!avatarSrc && <UserIcon width={26} height={26} />}
        </span>
        <div className="fui-profile__meta">
          <span className="fui-profile__name">{name}</span>
          {email && (
            <span className="fui-profile__email" title={email}>
              {email}
            </span>
          )}
        </div>
      </div>
      <div className="fui-profile__actions">
        {onSettings && (
          <button type="button" className="fui-profile__action" onClick={onSettings}>
            <GearIcon width={18} height={18} />
            <span>{settingsLabel}</span>
          </button>
        )}
        <button
          type="button"
          className="fui-profile__action fui-profile__action--logout"
          onClick={onLogout}
        >
          <LogoutIcon width={18} height={18} />
          <span>{logoutLabel}</span>
        </button>
      </div>
    </div>
  );
}
